import Skeleton from 'antd/lib/skeleton';
import View     from 'components/View';
import React    from 'react';

export default () => (
	<View className="single-row-skeleton-wrapper" minWidth={80}>
		<Skeleton active={true} className="single-row-skeleton" paragraph={false} />
	</View>
);